import { Place } from "./ResearchDataModel"
import { AsyncData, LoadMode } from "@webapp/util/AsyncData"
import { AsyncDataStore } from "@webapp/util/AsyncDataStore"
import { defineStore } from "pinia"
import { DateTime } from "luxon"
import { DateTimeUtil } from "@webapp/util/LuxonUtil"
import _, { uniqBy } from "lodash"
import { assignExisting, isDefined } from "@webapp/util/TypeScriptUtil"


export const usePlaceStore = defineStore("placeStore", () => {
    const asyncPlaces = new Map<string, AsyncData<Place>>()

    function trackAsyncPlace(placeId: string | undefined) {
        return placeId ? trackAsyncPlaces([placeId])[0] : undefined
    }

    function trackAsyncPlaces(placeIds: string[]) {
        const store = usePlaceStore() // use to get/return reactive store objects
        AsyncDataStore.getAsyncItemsToLoad(store.asyncPlaces, placeIds, "Place", LoadMode.TrackOnly)
        return placeIds.map(id => store.asyncPlaces.get(id)!)
    }

    function addPlacesToStore(plainPlaces: any[], requestTime: DateTime) {
        const store = usePlaceStore() // use to get/return reactive store objects
        const placeMap = AsyncDataStore.createItemMap(uniqBy(plainPlaces, 'id'), "Place", plainToPlace, pl => pl.id!)
        AsyncDataStore.addItemMapToStore(store.asyncPlaces, "Place", placeMap, requestTime)
    }

    return {
        asyncPlaces,

        trackAsyncPlace,
        trackAsyncPlaces,
        addPlacesToStore,
    }
})

function plainToPlace(p: any) {
    const place = assignExisting(new Place(), p)
    place.modifiedDate = DateTimeUtil.fromAPI(p.modifiedDate)
    return place
}
